import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import { Task } from "../../services/swagger";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import useBreakpoint from "../../hooks/useBreakpoint";
import OptionsButton from "./OptionsButton";

interface TaskDialogHeaderProps {
  title: string;
  subtitle?: string;
  onDelete?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  task: Task;
  onStart?: () => void;
  onStop?: () => void;
}

export default function TaskDialogHeader(props: TaskDialogHeaderProps) {
  const { t } = useTranslation("TaskDialog");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const open = Boolean(anchorEl);
  const breakpoint = useBreakpoint();
  return (
    <Box
      p={2}
      py={1}
      boxSizing="border-box"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="column" spacing={0.5}>
        <Typography fontWeight={600} variant="h6" color="primary">
          {props.title}
        </Typography>
        {props.subtitle && (
          <Typography fontWeight={400} color="textSecondary">
            {props.subtitle}
          </Typography>
        )}
      </Stack>

      <Stack direction="row" spacing={1}>
        {!props.task.cancelled && (
          <>
            {!props.task.timelog?.some((log) => !log.endDate) ? (
              breakpoint.md ? (
                <Button
                  variant="contained"
                  color="success"
                  onClick={props.onStart}
                  startIcon={<PlayArrowIcon />}
                >
                  {t("Start")}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="success"
                  onClick={props.onStart}
                >
                  <PlayArrowIcon />
                </Button>
              )
            ) : breakpoint.md ? (
              <Button
                variant="contained"
                color="warning"
                onClick={props.onStop}
                startIcon={<StopIcon />}
              >
                {t("Stop")}
              </Button>
            ) : (
              <Button
                variant="contained"
                color="warning"
                onClick={props.onStop}
              >
                <StopIcon />
              </Button>
            )}
          </>
        )}
        <OptionsButton
          options={[
            {
              icon: <DoNotDisturbAltIcon color="error" />,
              label: t("CancelTask"),
              onClick: props.onCancel,
              closeOnClick: true,
              hidden: props.task.cancelled,
            },
            {
              icon: <DeleteIcon color="error" />,
              label: t("DeleteTask"),
              onClick: props.onDelete,
            },
          ]}
        />
        <IconButton onClick={props.onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
    </Box>
  );
}
